import React, {useContext, useEffect, useState} from 'react';
import {SidebarContext} from "../../../SidebarContext";

function ScrollableContainer(props) {
    const {selectedRetailer} = useContext(SidebarContext)

    const [shouldResetScroll, setShouldResetScroll] = useState(false)

    useEffect(() => {
        if (selectedRetailer) {
            setShouldResetScroll(true)
        }
    }, [selectedRetailer]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                flex: 1,
                overflowY: 'auto'
            }}
            ref={el => {
                if (el && shouldResetScroll) {
                    el.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                    setShouldResetScroll(false)
                }
            }}
        >
            {props.children}
        </div>
    );
}

export default ScrollableContainer;
